/**
 * contractDetailInvoiceApi — RTK Query slice cho dialog Contract Detail →
 * Add Invoice (batch). File RIÊNG (không sửa contractDetailApi.ts dùng chung).
 *
 * Backend: app/api/v1/endpoints/purchase/contract_detail_invoice.py
 *   POST /purchase/contract-detail/invoice-batch
 *
 * Types snake_case khớp BE (app/models/purchase/contract_detail_invoice.py).
 */
import { baseApi } from './baseApi'

/** Một dòng grid nhập (Access tmp_addmany_pay_invoice). */
export interface InvoiceBatchRowIn {
  warehouse: string | null
  invoice_no: string | null
  /** 'YYYY-MM-DD' */
  invoice_date: string | null
  quantity: number | null
  price_vnd_kg: number | null
  total_amount: number | null
  vat_amount: number | null
  description: string | null
}

export interface InvoiceBatchRequest {
  contract_no: string
  rows: InvoiceBatchRowIn[]
}

/** Access MsgBox "Raw records: N / Error: M". */
export interface InvoiceBatchResult {
  raw_records: number
  errors: number
}

export const contractDetailInvoiceApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    saveInvoiceBatch: b.mutation<InvoiceBatchResult, InvoiceBatchRequest>({
      query: (body) => ({
        url: '/purchase/contract-detail/invoice-batch',
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useSaveInvoiceBatchMutation } = contractDetailInvoiceApi
